// extracted by mini-css-extract-plugin
export default {"multipleActions":"MultipleActions_multipleActions__a6zdU","button":"MultipleActions_button__ndY8x"};